import { useNavigate } from "react-router-dom";

import { Models } from "api/types";

export const InclusionDetails = ({
  typedItem,
  inclusionType,
  isFreePackageGroup = false,
  disableNavigation = false,
}: {
  typedItem: Models<"InclusionModel">;
  inclusionType: string;
  isFreePackageGroup?: boolean;
  disableNavigation?: boolean;
}) => {
  const navigate = useNavigate();
  const navigationPath =
    inclusionType === "treatments" || inclusionType === "packages"
      ? "/pdp/package/"
      : inclusionType === "products"
      ? "/pdp/product/"
      : "/pdp/membership/";

  const item = typedItem as Models<"TreatmentInclusionModel">;

  const isTreatmentOrProduct =
    inclusionType === "treatments" || inclusionType === "products";

  const hasVariantsList = item.variants && item.variants.length > 0;

  const shouldShowVariants =
    isTreatmentOrProduct &&
    hasVariantsList &&
    (inclusionType !== "treatments" || !item.allVariants);

  const variantNames = item.variants?.map((v) => v.name).join(", ") ?? "";

  const quantityText =
    isFreePackageGroup && typedItem.quantity?.value
      ? ` (${typedItem.quantity.value} ${
          typedItem.quantity.value < 2
            ? typedItem.quantity.unitType.singularUnitType
            : typedItem.quantity.unitType.pluralUnitType
        })`
      : "";

  return (
    <li className="pl-5">
      {isFreePackageGroup || disableNavigation ? (
        <div className="py-[1px] text-left">
          {typedItem.name}
          {shouldShowVariants && (
            <span className="text-secondary"> - {variantNames}</span>
          )}
          {quantityText}
        </div>
      ) : (
        <div className="py-[1px] text-left">
          <button
            onClick={() => navigate(navigationPath + typedItem.id)}
            className="block cursor-pointer text-left hover:border-solid"
            aria-label={`Navigate to ${typedItem.name}`}
          >
            <span className="text-brand-color underline decoration-dotted decoration-1 underline-offset-4 ">
              {typedItem.name}
            </span>
            {shouldShowVariants && (
              <span className="text-secondary">&nbsp; ({variantNames})</span>
            )}
          </button>
          {quantityText}
        </div>
      )}
    </li>
  );
};
